import { render } from "./HomeComponent.vue?vue&type=template&id=8fc387a0"
import script from "./HomeComponent.vue?vue&type=script&lang=js"
export * from "./HomeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/home/HomeComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8fc387a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8fc387a0', __exports__)) {
    api.reload('8fc387a0', __exports__)
  }
  
  module.hot.accept("./HomeComponent.vue?vue&type=template&id=8fc387a0", () => {
    api.rerender('8fc387a0', render)
  })

}


export default __exports__